import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import {consoleUserSearchFields} from '../utils/searchFields';
import DataTable, {possibleStatus} from '../../../baseApp/shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';

const ConsoleUsersPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    data = [],
    entityList,
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property,
        direction
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t('consoleUser.list.username'),
        accessor: "username",
        sortable: true
    },  {
        Header: I18n.t('consoleUser.list.entity'),
        id: "entity",
        sortable: true,
        accessor: consoleUser => consoleUser.entity.name
    }, {
        Header: I18n.t('consoleUser.list.numberOfConnections'),
        accessor: "numberOfConnections",
    }, {
        Header: I18n.t('consoleUser.list.maxNumberOfConnections'),
        id: "properties",
        accessor: consoleUser => consoleUser.properties.maxNumberOfConnections,
    }, {
        Header: I18n.t('consoleUser.list.lastCommunication'),
        sortable: true,
        id: "lastCommunicationTimestamp",
        accessor: consoleUser => consoleUser.lastCommunication
    }];

    return <div className="page_background">
        <SearchForm
            content={consoleUserSearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.CONSOLE_USER}
        />
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={true}
                statusBarAccessor={consoleUser => {
                    switch (consoleUser.active) {
                        case true:
                            return possibleStatus.active;
                        case false:
                            return possibleStatus.inactive;
                        default:
                            return possibleStatus.uncertain;
                    }
                }}
            />
        </div>
    </div>
};

ConsoleUsersPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default ConsoleUsersPage;